import Image from 'next/image'
import { cn } from '@/lib/utils'

type WashIntensity = 'soft' | 'medium' | 'strong'

interface WashedPortraitProps {
    src: string
    alt: string
    wash?: string
    intensity?: WashIntensity
    sizes?: string
    priority?: boolean
    position?: string
    className?: string
    imageClassName?: string
}

/**
 * Full-colour portrait with a soft dark vignette and a faint warm light from above.
 */
export const WashedPortrait = ({
    src,
    alt,
    sizes = '(min-width: 1024px) 25vw, (min-width: 640px) 45vw, 90vw',
    priority = false,
    position = 'center 25%',
    className,
    imageClassName
}: WashedPortraitProps) => {
    return (
        <div className={cn('absolute inset-0 isolate overflow-hidden', className)}>
            <Image
                src={src}
                alt={alt}
                fill
                sizes={sizes}
                priority={priority}
                className={cn('object-cover transition-transform duration-[1400ms] ease-cinema', imageClassName)}
                style={{ objectPosition: position }}
            />

            <div
                aria-hidden='true'
                className='absolute inset-0 bg-[radial-gradient(130%_95%_at_50%_30%,rgba(0,0,0,0)_45%,rgba(8,6,4,0.55)_100%)]'
            />

            <div
                aria-hidden='true'
                className='absolute inset-0 bg-[linear-gradient(180deg,rgba(255,196,140,0.14)_0%,rgba(255,196,140,0)_35%)] mix-blend-soft-light'
            />
        </div>
    )
}
